import { add } from 'date-fns';
import { TpaMonthsMatrix } from './useTPA';

export const calculateTpaAmounts = (balance: number, month: number) => {
  const monthlyInstallment = balance / month;
  const arrangementAmount = Math.floor(monthlyInstallment); // extract round value
  const decimalMonthlyInstallment = monthlyInstallment - arrangementAmount; // extract decimal value
  const downPaymentAmountValue =
    decimalMonthlyInstallment * month + arrangementAmount; //downPaymentAmount without rounding
  const downPaymentAmount = convertToHigherValue(downPaymentAmountValue, 2); //downPaymentAmount value round up to higher value ex: 34.23456 -> 34.24
  // calculating new balance amount using down payment(round up to higher value)
  const newCalculatedBalance: number =
    downPaymentAmount + arrangementAmount * (month - 1);
  const difference = newCalculatedBalance - balance; // difference between original and newly calculated balance
  const downPaymentAmountDecimal = downPaymentAmount - difference;

  return {
    arrangementAmount,
    downPaymentAmount: convertToHigherValue(downPaymentAmountDecimal, 2),
  };
};

export const convertToHigherValue = (amount: number, decimal: number) => {
  const fixedAmount: any = amount.toFixed(decimal + 1); //convert number to one extra decimal value
  const roundAmount = Math.floor(fixedAmount); // get only integer
  let decimalValue: any = Math.abs(fixedAmount - roundAmount); //get only decimal values eg. 0.543
  decimalValue = decimalValue.toFixed(decimal + 1) * Math.pow(10, decimal + 1); //convert the decimal number to normal integer eg. 0.543 to 543
  decimalValue =
    decimalValue % 10 < 5 && decimalValue % 10 > 0
      ? decimalValue + 5
      : decimalValue; // if last digit is between 1 to 4 add 5 to it for rounding up eg. 543 to 548. For last digit greater than 5 keep same number
  decimalValue = Math.ceil(decimalValue); // get the highest value of number
  decimalValue = decimalValue / Math.pow(10, decimal + 1); // convert the number to decimal it.e.g 548 to 0.548
  const convertAmount = roundAmount + decimalValue; //adding round amount to decimal value eg: 23 + 548 = 23.548
  return Number(convertAmount.toFixed(decimal)); //reducing decimal to desired value i.e 23.55
};

export const calculateTpaInstallmentAmount = (
  amount: number,
  months: number,
) => {
  const monthlyInstallment = amount / months;
  return Math.floor(monthlyInstallment); // get only integer.
};

export const setFirstPaymentToCompleted = (tpaMatrix: TpaMonthsMatrix[]) => {
  if (tpaMatrix && tpaMatrix[0] && !tpaMatrix[0].isPaymentCompleted) {
    tpaMatrix[0].isPaymentCompleted = true;
  }
  return tpaMatrix;
};
